/* eslint-disable max-len */
import React from 'react';

const AlignCenterIcon = props => (
  <svg width={19} height={19} viewBox="0 0 19 19" version="1.1" {...props}>
    <defs>
      <path
        d="M15.7454545,15 C15.8860361,15 16,15.0895431 16,15.2 L16,15.8 C16,15.9104569 15.8860361,16 15.7454545,16 L2.25454545,16 C2.11396388,16 2,15.9104569 2,15.8 L2,15.2 C2,15.0895431 2.11396388,15 2.25454545,15 L15.7454545,15 Z M12.8,6 C12.9104569,6 13,6.08954305 13,6.2 L13,12.8 C13,12.9104569 12.9104569,13 12.8,13 L5.2,13 C5.08954305,13 5,12.9104569 5,12.8 L5,6.2 C5,6.08954305 5.08954305,6 5.2,6 L12.8,6 Z M12,7 L6,7 L6,12 L12,12 L12,7 Z M15.7454545,3 C15.8860361,3 16,3.08954305 16,3.2 L16,3.8 C16,3.91045695 15.8860361,4 15.7454545,4 L2.25454545,4 C2.11396388,4 2,3.91045695 2,3.8 L2,3.2 C2,3.08954305 2.11396388,3 2.25454545,3 L15.7454545,3 Z"
        id="alignCenterPath"
      />
    </defs>
    <g id="Image_Center" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <mask fill="white">
        <use xlinkHref="#alignCenterPath" />
      </mask>
      <use fill="currentColor" fillRule="nonzero" xlinkHref="#alignCenterPath" />
    </g>
  </svg>
);

export default AlignCenterIcon;
